module.exports = __webpack_public_path__ + "img/cropped-Avatar-Square-1.3e183961.png";